import { CodedProperty, fluentValidator, stringArraysEqual, ValidationResult } from "sprint-common-web";

import { SuggestContentListByTitleResponseTvEpisodeVersion } from "../../../../../common/api/catalogue-api/contents-api/SuggestContentListByTitleResponse";
import { isTrailerVersionType } from "../../../../../common/types/TrailerContentVersion";

export const createOrderEpisodeItemValidator = () => {
    const validateVersion = (
        versionToValidate: SuggestContentListByTitleResponseTvEpisodeVersion,
        allVersions: SuggestContentListByTitleResponseTvEpisodeVersion[]
    ): ValidationResult => {
        return fluentValidator<SuggestContentListByTitleResponseTvEpisodeVersion>()
            .when((version) => !!version.buzzVersion?.notes && (version.brandings ?? []).length < 1)
            .addWarning((version) => version.buzzVersion?.notes ?? "")
            .when((version) => !version.buzzVersion?.id && !isTrailerVersionType(version.type))
            .addWarning("Version is orphaned")
            .when((version) => !!version.buzzVersion?.isArchived)
            .addWarning("Version is archived")
            .when((version) => isDuplicated(allVersions, version))
            .addWarning((version) => version.buzzVersion?.name ?? "Version is duplicated")
            .validate(versionToValidate);
    };

    return {
        validateVersion
    };
};

const isDuplicated = (
    allVersions: SuggestContentListByTitleResponseTvEpisodeVersion[],
    versionToValidate: SuggestContentListByTitleResponseTvEpisodeVersion
) => {
    return (
        allVersions.filter(
            (version: SuggestContentListByTitleResponseTvEpisodeVersion) =>
                version.type.id === versionToValidate.type.id &&
                version.distributor.id === versionToValidate.distributor.id &&
                brandingsEqual(versionToValidate.brandings, version.brandings)
        ).length > 1
    );
};

const brandingsEqual = (brandings1?: CodedProperty[], brandings2?: CodedProperty[]) => {
    const brandings1Ids = brandings1?.map((brand: CodedProperty) => brand.id) ?? [];
    const brandings2Ids = brandings2?.map((brand: CodedProperty) => brand.id) ?? [];

    return stringArraysEqual(brandings1Ids, brandings2Ids);
};
